var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLindsayAdamsMediaAndDesignBrantOntarioFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "95.5px",
    height: "95.5px",
    viewBox: "0 0 95.5 95.5",
    style: {
      enableBackground: "new 0 0 95.5 95.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1F2022;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0.6v94.2c0,0.3,0.3,0.6,0.6,0.6h94.2c0.3,0,0.6-0.3,0.6-0.6V0.6c0-0.3-0.3-0.6-0.6-0.6H0.6 C0.3,0,0,0.3,0,0.6z M26.6,68.4V28.1c0-0.6,0.7-0.8,1.1-0.4l40.2,40.2c0.4,0.4,0.1,1.1-0.4,1.1H27.2C26.9,69,26.6,68.7,26.6,68.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLindsayAdamsMediaAndDesignBrantOntarioFavicon);
export default __webpack_public_path__ + "static/media/lindsay-adams-media-and-design-brant-ontario-favicon.58bd2c6d6ee7f61acbd8261d008ffd97.svg";
export { ForwardRef as ReactComponent };